import { render } from "./editMelk.vue?vue&type=template&id=b4b92544&scoped=true"
import script from "./editMelk.vue?vue&type=script&lang=js"
export * from "./editMelk.vue?vue&type=script&lang=js"

import "./editMelk.vue?vue&type=style&index=0&id=b4b92544&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b92544"]])

export default __exports__